import React from 'react';
import { Brain, CheckCircle } from 'lucide-react';

export const ProDifferentiation: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div>
            <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-3 leading-tight uppercase">
              Pas un outil de calcul de plus.<br />La connaissance d'un expert, accessible en deux minutes.
            </h2>
            <div className="w-12 h-0.5 bg-blue-500 mb-8"></div>

            <div className="space-y-6 text-gray-600 leading-relaxed">
              <p>
                La majorité des outils DPE récupèrent les données ADEME et affichent un résultat. DPEWizard fait autre chose : il pose d'abord une série de questions simples sur le bien et son usage. Résidence principale, investissement locatif, revente rapide ? Les travaux pertinents ne sont pas les mêmes. L'isolation est-elle faisable sans tout casser ? Une isolation extérieure est-elle autorisée ? Les murs sont-ils en pierre ou en brique ?
              </p>
              <p>
                Des questions accessibles à n'importe qui. Pas de jargon technique, pas de connaissance travaux requise.
              </p>
              <p>
                Derrière ces questions simples, un moteur de règles absorbe toute la complexité : choix des matériaux, épaisseurs, équipements compatibles avec la configuration du bien. L'utilisateur ne voit pas ce travail. Il voit un scénario cohérent, avec des coûts estimés sur des bases réalistes.
              </p>
              <p className="font-medium text-gray-800">
                C'est quinze ans d'expérience terrain en investissement immobilier, encodés dans un algorithme. Ce que les autres outils ne font pas.
              </p>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm">
              <div className="flex items-center gap-4 mb-6">
                <div className="flex items-center justify-center w-12 h-12 bg-blue-50 rounded-xl">
                  <Brain className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="text-lg font-bold text-gray-900">Ce que le moteur prend en compte</h3>
              </div>
              <div className="space-y-3">
                {[
                  "Objectif de l'opération (résidence, locatif, revente)",
                  "Nature des murs (pierre, brique, béton…)",
                  "Faisabilité de l'isolation extérieure",
                  "Compatibilité des équipements",
                  "Épaisseurs et matériaux adaptés au bâti",
                  "Contraintes architecturales et réglementaires",
                  "Etc."
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-600">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-blue-50 border border-blue-100 rounded-xl p-6">
              <p className="text-sm text-blue-800 leading-relaxed">
                <span className="font-semibold">Sur les aides :</span> elles dépendent de plus de 400 critères individuels. DPEWizard ne les intègre pas dans ses calculs pour ne pas promettre ce qu'il ne peut pas garantir. Les liens vers les simulateurs officiels sont disponibles dans l'outil.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProDifferentiation;
